import { createBrowserRouter } from "react-router-dom";
import { PathConstants } from "./paths";

import Home from "../pages/Home";
import MainLayout from "../layout/mainLayout";
import DocumentDetails from "../pages/DocumentDetails";
import SignupPage from "../pages/Signup";
import Login from "../pages/Login";
import Contracts from "../pages/Contracts";
import ContractDetails from "../pages/ContractDetails";
import Users from "../pages/Users";
import CompleteUserInformations from "../pages/CompleteUserInformations";
import Dashboard from "../pages/Dashboard";
import BusinessPartners from "../pages/BusinessPartners";
import ContractTemplates from "../pages/ContractTemplates";
export const MainRouter = createBrowserRouter([
  {
    path: PathConstants.Home,
    element: <Home />,
  },
  // {
  //   path: PathConstants.DocumentDetails,
  //   element: <MainLayout><DocumentDetails /></MainLayout>,
  // },
  // {
  //   path: PathConstants.Signup,
  //   element: <SignupPage/>,
  // },
  // {
  //   path: PathConstants.Login,
  //   element: <Login/>,
  // },
  // {
  //   path: PathConstants.Contracts,
  //   element: <MainLayout><Contracts/></MainLayout>,
  // },
  // {
  //   path: PathConstants.ContractDetails,
  //   element: <MainLayout><ContractDetails/></MainLayout>,
  // },
  // {
  //   path: PathConstants.Users,
  //   element: <MainLayout><Users/></MainLayout>,
  // },
  // {
  //   path: PathConstants.OrgVerification,
  //   element: <CompleteUserInformations />,
  // },
  // {
  //   path: PathConstants.UserVerification,
  //   element: <CompleteUserInformations />,
  // },
  // {
  //   path: PathConstants.UserVerification,
  //   element: <CompleteUserInformations />,
  // },
  // {
  //   path: PathConstants.Dashboard,
  //   element: <MainLayout><Dashboard /></MainLayout>,
  // },
  // {
  //   path: PathConstants.Business,
  //   element: <MainLayout><BusinessPartners /></MainLayout>,
  // },
  // {
  //   path: PathConstants.Contract_templates,
  //   element: <MainLayout><ContractTemplates /></MainLayout>,
  // },
  
]);
